export default () => {

  const c = {}
  const init = () => {
    c.root = document.querySelector('.l-conversion');
    if (!c.root) {
      return;
    }

    buildConversion();
  }

  const buildConversion = () => {
    c.upLimitElement = document.querySelector('.l-system .c-btn-rcorner');
    c.downLimitElement = document.querySelector('.l-purchase');

    switchConversionStatus();
    watchScrollAction();

    window.addEventListener('resize', () => {
      resize();
    });
    resize();
  }

  const switchConversionStatus = () => {
    if (isCrossPosition()) {
      c.root.classList.add('is-visibled');
    } else {
      c.root.classList.remove('is-visibled');
    }
  }
  const watchScrollAction = () => {
    c.raf = window.requestAnimationFrame(() => {
      switchConversionStatus();
      watchScrollAction();
    })
  }

  const isCrossPosition = () => {
    const upCurrentPos = getUpEleTopPos();
    const downCurrentPos = getDownEleTopPos();
    return upCurrentPos < (c.wh * (1 - .8)) && downCurrentPos > c.wh;
  }
  const getUpEleTopPos = () => {
    return c.upLimitElement.getBoundingClientRect().top | 0;
  }
  const getDownEleTopPos = () => {
    return c.downLimitElement.getBoundingClientRect().top | 0;
  }
  const resize = () => {
    c.wh = window.innerHeight;
  }

  init();
}
